import { GlobalStylesBk } from '@rbilabs/components-library/build/globalStyles';

export const BrandGlobalStyles = GlobalStylesBk;
